
<div class="shop-widget">
  <align class="header" flex>
    <align>
      <h3 class="secondary-font">
        Shop
      </h3>

      <saved-filters
        hide-save
        type="shop"
        align="left"
        allow-deselect
        :query="activeSavedFilter ? activeSavedFilter.query : ''"
        :filters="activeSavedFilter ? activeSavedFilter.filters : {}"
        :is-filtering="!!activeSavedFilter"
        @select="selectSavedFilter"
      />
    </align>

    <icon-link @click.native="viewShop">
      View More
    </icon-link>
  </align>

  <p class="affiliate-text">
    If you purchase an item from the results below after clicking the link, Card Ladder may be compensated at no additional cost to you.
  </p>

  <div v-if="items.length > 0">
    <div class="grid">
      <shop-listing-card
        v-for="item in items"
        :key="item.listingId"
        :item="item"
        :href="item.url"
        target="_blank"
        rel="noopener noreferrer"
      />
    </div>
  </div>

  <div v-else-if="!loading">
    There are no listings matching your saved search.
  </div>
</div>
